/* eslint no-console:0 */

import "./application.css"
import "rails/boot"
import "features/players_fields_animations.js"
import "features/levels_fields_animations.js"

